import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import dayjs from 'dayjs';

import { FileDetail, InfoDetailResType, useGetInfoDetailApi } from '@/api/notice';
import infoBanner from '@/assets/img/banner/information.jpg';
import shareIcon from '@/assets/img/icon/shareIcon.svg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalShare from '@/components/common/Modal/ModalShare/ModalShare';
import DownloadIcon from '@/components/Icon/DownloadIcon';
import LineIcon from '@/components/Icon/lineIcon';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import { useAuthStore } from '@/store/authStore';
import { convertInfoValue } from '@/utils/convertValue';
import { downloadFile } from '@/utils/fileUtils';

import * as S from './style';

interface IProps {
	communityBoard?: boolean;
}

const InformationDetail = ({ communityBoard }: IProps) => {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { id } = params;
	const paramsMenu = location.state?.menu ?? '자유게시판';
	const userPk = useAuthStore((state) => state.pk);

	const { data: infoDetailData } = useGetInfoDetailApi({
		info_pk: id ?? '',
		type: convertInfoValue(paramsMenu),
	});

	const getDynamicField = (g: any, field: string) => {
		const type = convertInfoValue(paramsMenu);
		return g[`${type}_${field}`] || ''; // 동적으로 필드 처리
	};
	const getDynamicFieldFile = (data: InfoDetailResType | undefined, field: string): FileDetail[] | undefined => {
		const type = convertInfoValue(paramsMenu); // 예: 'notice'
		const key = `${type}_${field}` as keyof InfoDetailResType;
		const value = data?.[key];
		return Array.isArray(value) ? value : undefined;
	};
	const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;

	const handleEdit = () => {
		navigate(`/information/`, {
			state: {
				menu: paramsMenu,
				step: '수정',
				data: {
					pk: id,
					title: getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'title'),
					content: getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'content'),
					files: getDynamicFieldFile(infoDetailData, 'file') ?? [],
				},
			},
		});
	};

	useEffect(() => {
		console.log(`infoDetailData : `, infoDetailData);
	}, []);
	const handleDelete = () => {
		alert('Call delete API');
	};

	return (
		<>
			<main>
				<SubBanner subTitle="Information" title="자료실" img={infoBanner} />
				<S.ConferenceContainer>
					<S.ConferenceHeader>
						<S.ConferenceTitleBox>
							<S.ConferenceTitle>{getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'title') ?? ''}</S.ConferenceTitle>
							<S.ConferenceSubTitle>
								{dayjs(getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'enrollment_date')).format('YYYY-MM-DD') ?? ''}
								<LineIcon />
								조회수:
								{getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'hit')
									? getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'hit')
									: '0'}
								<LineIcon />
								작성자: {infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]?.admin_name}
							</S.ConferenceSubTitle>
						</S.ConferenceTitleBox>
						<div className="share_icon">
							{communityBoard && userPk === (infoDetailData?.forum?.member_pk ?? '') && (
								<S.EditButtonBox>
									<button onClick={handleEdit}>수정</button>
									<button onClick={handleDelete}>삭제</button>
								</S.EditButtonBox>
							)}
						</div>
					</S.ConferenceHeader>
					<S.ContentBox>
						<S.Content
							dangerouslySetInnerHTML={{ __html: getDynamicField((infoDetailData && infoDetailData[convertInfoValue(paramsMenu)]) ?? '', 'content') ?? '' }}
						/>
						<S.DownLoadBoxList>
							{infoDetailData &&
								getDynamicFieldFile(infoDetailData, 'file')?.map((item, index) => (
									<S.DownLoadBox key={index} onClick={() => downloadFile(item.file_path ?? '', item.file_pk ?? '')}>
										<S.DownLoadContent>
											<div className="title">{item.file_original_name ?? ''}</div>
											<div className="sub_title">{formatBytesToKB(item.file_size ?? 0)}</div>
										</S.DownLoadContent>
										<DownloadIcon iconColor="#ADB5BD" width="20" height="20" />
									</S.DownLoadBox>
								))}
						</S.DownLoadBoxList>
						<S.MenuBox>
							<S.MenuList>
								{!infoDetailData?.prev_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/information/community/${infoDetailData?.prev_pk}`, { state: { menu: paramsMenu } })}>
										<SingleArrowPrev iconColor="#212529" width="18" height="18" /> 이전글
									</S.Menu>
								)}
								{!infoDetailData?.next_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/information/community/${infoDetailData?.next_pk}`, { state: { menu: paramsMenu } })}>
										다음글
										<SingleArrowNext iconColor="#212529" width="18" height="18" />
									</S.Menu>
								)}
							</S.MenuList>
							<S.MenuList>
								<S.MenuActive type="button" onClick={() => navigate('/Information', { state: { menu: paramsMenu } })}>
									목록
								</S.MenuActive>
							</S.MenuList>
						</S.MenuBox>
					</S.ContentBox>
				</S.ConferenceContainer>
			</main>
		</>
	);
};

export default InformationDetail;
